export default "__VITE_ASSET__BOtnkXOU__"